export default "__VITE_ASSET__zYWV0dKb__"